import React, { Component } from "react";
import ReportTableSectionRenderer from "../../../../../../libraries/ReportGenerator";
import { SchemaFor92And184DaysChecklist } from "./Schema";
import {
  BlueCardItemsTitleSchema,
  BlueCardItemsDataSchema,
  EngineHoursSchema,
  PersonPerformingSchema,
  BlueCardItemsTableSchema,
} from "../92And184DaysSchema";
import { MapReportTitle } from "../../mapSchema";
import { getSupportingDocuments } from "../../../AirBrakeReports/AirBrakeReports/CommonFunctions";
const titleOfReport = (testCode) => MapReportTitle[testCode];
const CLMB_Periodic92And184DaysReport = (props) => {
  const { singleReport } = props;
  const { user } = singleReport;
  return (
    <div>
      <span className="spacer"></span>
      <div style={{ textAlign: "center" }}>
        <h2 style={{ fontWeight: "bolder" }}>{titleOfReport(singleReport.testCode) || singleReport.title}</h2>
      </div>
      <table className="table-bordered">
        <ReportTableSectionRenderer section={EngineHoursSchema} rowsData={singleReport.summary} />
      </table>
      <table className="table-bordered">
        {/* blue card items */}
        {BlueCardItemsTitleSchema.map((section, index) => {
          return (
            <ReportTableSectionRenderer
              section={section}
              rowsData={{ ...singleReport.summary, userName: (user && user.name) || "" }}
              key={index}
            />
          );
        })}

        {singleReport.summary && singleReport.summary.inspector_items ? (
          <ReportTableSectionRenderer section={BlueCardItemsTableSchema} rowsData={singleReport.summary.inspector_items} />
        ) : (
          BlueCardItemsDataSchema.map((section, index) => {
            return (
              <ReportTableSectionRenderer
                section={section}
                rowsData={{ ...singleReport.summary, userName: (user && user.name) || "" }}
                key={index}
              />
            );
          })
        )}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.labOilSample.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.replaceAllFilters.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.brushFusesDiodes.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.safetyAppliances.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.brakeShoes.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.truckUndercarriage.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.draftGear.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.handBrake.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.inspectAllBaseBolts.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.batteriesAndChargingSystem.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.electricalGrounds.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.lightingAndIllumination.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.locksAndSecurement.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.HouseKeeping.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.pcSystem.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.electricalCabinets.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.protectiveAndShutdown.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.cabAndLocomotiveSafetyEquipments.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.controlStandThrottle.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>

      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.muReceptaclesJumperCables.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.transitionCircuit.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.speedIndicator.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.engineCoolingSystem.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.primeMoversDieselEngineInspection.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.accessoryDriveADA.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.checkFluidLevel.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.sandOperationApplication.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.washCleanLocomotive.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.airBrakeSystemTests.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        <ReportTableSectionRenderer section={SchemaFor92And184DaysChecklist.wheelGeometryAndMiscClearance[0]} rowsData={{}} />
        <ReportTableSectionRenderer
          section={SchemaFor92And184DaysChecklist.wheelGeometryAndMiscClearance[1]}
          rowsData={(singleReport.summary && singleReport.summary.tab1) || []}
        />
        <ReportTableSectionRenderer
          section={SchemaFor92And184DaysChecklist.wheelGeometryAndMiscClearance[2]}
          rowsData={(singleReport.summary && singleReport.summary.tab2) || []}
        />
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.coupleHeight.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.pilotHeight.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.sideBearingClearance.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>
      <table className="table-bordered">
        {SchemaFor92And184DaysChecklist.updateDocumentation.map((section, index) => {
          return <ReportTableSectionRenderer section={section} rowsData={singleReport.summary} key={index} />;
        })}
      </table>

      {Object.keys(singleReport.summary).includes("supportingDocuments") && getSupportingDocuments(singleReport.summary)}
    </div>
  );
};

export default CLMB_Periodic92And184DaysReport;



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/Periodic/92And184Days/CLMB/index.jsx